module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/anchor-left-703221a22481937bb06cd9cb41c9e1ae.svg";